import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=23c23996&"
import script from "./ShopList.vue?vue&type=script&lang=js&"
export * from "./ShopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports